import { useChatContext } from "@/services/chat-provider"
import ChatImage from "../ChatImage"
import { getModalityLabel } from "../chat-report-panel/ReportFormDialog"
import { byIdentifier } from "@minohealth/common/utils/ids"
import { RiExternalLinkLine } from "react-icons/ri"

/**
 * @param {Object} props
 * @param {import("./utils").AgentMessageReport[number]} props.report
 * @param {(string | import("../@types").ChatImage)[]} props.reportImages
 * @param {import("../chat-bubble").ChatMessageBubbleProps["previewReport"]} props.previewReport
 */
function ChatBubbleReportCard({ report, reportImages = [], previewReport }) {
  const { useActiveChatSessionImages } = useChatContext()

  const { data: chatImages } = useActiveChatSessionImages()

  const reportObj = {
    patientInfo: {
      name: "",
      age: report.age,
      gender: report.gender,
      id: ""
    },
    modality: report.modality,
    images: reportImages,
    original: report.content,
    current: typeof report.content === 'object' ? JSON.stringify(report.content) : report.content,
  }

  const firstReportImage = reportImages[0]
  const reportImage = (() => {
    if (firstReportImage == null) return null
    if (typeof firstReportImage === "object") return firstReportImage
    return chatImages?.find(byIdentifier(firstReportImage)) ?? null
  })()

  const handleClick = () => {

    if (!previewReport) {
      return;
    }

    if (report._id != null) {
      previewReport({ type: "ref", ref: report._id });
    } else {
      previewReport({ type: "report", report: reportObj });
    }
  };

  return (
    <button
      className="flex items-center gap-4 p-4 bg-card border border-border rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 mb-4 w-full text-left"
      onClick={handleClick}
      title="Open report"
    >
      <ChatImage
        srcImage={reportImage}
        thumbnail
        className="w-16 h-16 rounded-md object-cover flex-shrink-0 bg-muted border-2"
      />

      <div className="flex-1 min-w-0">
        <div className="space-y-1">
          <p className="text-sm text-muted-foreground">
            {getModalityLabel(reportObj.modality)}
          </p>
          <p className="text-sm text-muted-foreground">
            {reportObj.patientInfo.age} years old
          </p>
        </div>
      </div>

      <div className="flex items-center justify-center w-10 h-10 rounded-md bg-primary/10 text-primary">
        <RiExternalLinkLine className="w-4 h-4" />
        <span className="sr-only">Open report</span>
      </div>
    </button>
  )
}

export default ChatBubbleReportCard